module.exports = __webpack_public_path__ + "static/img/4.cd6c93a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/4.png
// module id = rVBG
// module chunks = 0